import ModalReviews from './ModalReviews';

export default ModalReviews;
